import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { TASKS } from '@shared/api/endpoints';
import type { TaskSession } from '@tailorcast/shared-types';

interface TasksParams {
  page?: number;
  limit?: number;
  stage?: string;
}

interface TasksResponse {
  sessions: TaskSession[];
  total: number;
  page: number;
}

export function useTasks(params: TasksParams = {}) {
  const { page = 1, limit = 20, stage } = params;

  const searchParams = new URLSearchParams();
  searchParams.set('page', String(page));
  searchParams.set('limit', String(limit));
  searchParams.set('marketplace', 'bitrix');
  if (stage) searchParams.set('stage', stage);

  const url = `${TASKS.LIST}?${searchParams.toString()}`;

  return useQuery({
    queryKey: ['tasks', params],
    queryFn: () => api.get<TasksResponse>(url),
  });
}
